import { createContext, useContext, useEffect, useState } from "react";
import { sanityClient } from "./client";

export const AppContext = createContext();

const AppContainer = ({ children }) => {
  const [nav, setNav] = useState(false);
  const [blog, setBlog] = useState([]);
  const [coach, setCoach] = useState([]);
  const [player, setPlayer] = useState([]);

  const fetchPlayer = async () => {
    return await sanityClient
      .fetch(
        `*[_type == "player"]{
          _id,
            categories[] ->,
            country,
            date,
            jersey,
            slug{
            current
            },
              mainImage{
                asset->{
                  url
                }
              },
            name,
              state,
              surname,
              position
          }`
      )
      .then((data) => setPlayer(data))
      .catch((err) => console.log(err));
  };
  const fetchCoach = async () => {
    return await sanityClient
      .fetch(
        ` *[_type == "coach"]{
        _id,
          body,
          slug{
          current
          },
          title,
            mainImage{
              asset->{
                url
              }
            },
            _createdAt
          }| order(_createdAt asc)`
      )
      .then((data) => setCoach(data))
      .catch((err) => console.log(err));
  };

  const fetchSanity = async () => {
    return await sanityClient
      .fetch(
        `*[_type == "post"]{
        title,
       slug{
          current
        }   ,
          mainImage{
          asset->{
            _id,
            url,
            alt
          }
          }
        ,
          publishedAt,
          body,
          _id,
          description,
          author ->,
          categories[] ->,
          _createdAt
      } | order(_createdAt desc)`
      )
      .then((data) => setBlog(data))
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    setNav(false);
    fetchSanity();
    fetchCoach();
    fetchPlayer();
  }, []);

  console.log(nav);

  return (
    <AppContext.Provider value={{ nav, setNav, blog, setBlog, coach, player }}>
      {children}
    </AppContext.Provider>
  );
};
export default AppContainer;

export const useGlobalContext = () => {
  return useContext(AppContext);
};
